<div class="container mt-4">
	<div class="inbox_listing_and_chat">
		<div class="left_side">
			<div class="headind_srch p-4 row">
				<div class="srch_bar col-8">
					<div class="stylish-input-group">
						<input
							type="text"
							class="search-bar p-2"
							placeholder="Rechercher"
							[(ngModel)]="searchedInput"
						/>
						<span class="input-group-addon">
							<button type="button">
								<i class="bi bi-search" aria-hidden="true"></i>
							</button>
						</span>
					</div>
				</div>

				<button
					class="col-4 btn theme-green-button"
					type="button"
					(click)="createNewConversation()"
				>
					<i class="fs-5 bi bi-plus-lg" aria-hidden="true"></i>
					Ajouter
				</button>
			</div>
			<!-- Zone du listing des conversations -->
			<div class="inbox_conversation">
				<div
					*ngFor="
						let conversation of conversations
							| filterConversationBySenderIdentity: searchedInput;
						index as conversationIndex
					"
					class="conversation_item"
					[ngClass]="
						currentConversationIndex === conversationIndex &&
						'active_conversation'
					"
				>
					<div
						class="conversation"
						profile="button"
						(click)="changeActiveConversation(conversationIndex)"
					>
						<div class="conversation_img">
							<img
								src="assets/img/isybuddyMessagerie.webp"
								alt="icone isybuddy messagerie"
							/>
						</div>
						<div class="conversation_overview">
							<h5>
								{{ conversation.user.firstName }}
								{{ conversation.user.lastName }}
								<span class="conversation_date">{{
									this.getLastMessageOfConversation(conversation)
										? (this.getLastMessageOfConversation(conversation).createdAt
										  | date: 'dd/MM/yyyy')
										: ''
								}}</span>
							</h5>
							<p>
								{{ this.getLastMessageContentFormatted(conversation) }}
							</p>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="right_side p-4">
			<!-- Zone de l'historique des messages -->
			<div class="zone-conversation" #scrollContainer>
				<div
					*ngFor="
						let message of currentMessageList;
						index as messageIndex;
						let last = last
					"
					[ngClass]="
						message.idSender === currentUser?.id
							? 'd-flex flex-row-reverse'
							: ''
					"
				>
					<div class="w-50 mb-3 me-3">
						<p
							id="{{ messageIndex }}"
							class="p-2 fs-6 message fw-bold"
							[ngClass]="
								message.idSender === currentUser?.id
									? 'sent_msg theme-blue-background-color'
									: 'received_msg theme-pink-background-color'
							"
						>
							{{ message.messageContent }}
						</p>
						<span class="time_date mt-2">
							{{ message.createdAt | date: 'dd/MM/yyyy | hh:mm' }}</span
						>
					</div>
					<!-- SI C'EST LE DERNIER ÉLÉMENT ON SCROLL JUSQU'À LUI -->
					{{ last ? scrollToBottom() : '' }}
				</div>
			</div>

			<!-- Zone de saisie de message -->
			<div class="type_msg">
				<div class="row mt-3 input_msg_write">
					<div class="col-10">
						<textarea
							placeholder="Type a message"
							[(ngModel)]="currentMessage"
						></textarea>
					</div>
					<div class="col-2 d-flex justify-content-center align-items-center">
						<button
							class="btn theme-green-button w-75"
							type="button"
							(click)="sendMessage()"
						>
							Envoyer
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
